module.exports = __webpack_public_path__ + "img/price-click-4.0765174b.jpg";